import React, { useState, createContext, useContext } from 'react';
export type Language = 'en' | 'fr' | 'es';
type TranslationKey = string;
type Translations = Record<Language, Record<TranslationKey, string>>;
const translations: Translations = {
  en: {
    // Welcome
    'welcome.headline': 'How can we help?',
    'welcome.find': 'Find Product Locations',
    'welcome.list': 'Build a Shopping List',
    'welcome.mostPopular': 'Most Popular',
    'welcome.diy': 'DIY Project Instructions',
    'welcome.contractor': 'Trusted Contractor Quotes',
    'welcome.deals': "Today's DEALS",
    'welcome.orDescribe': 'Talk with AI-Associate',
    'welcome.talkToAI': 'Talk with AI-Associate',
    'welcome.addMoreItems': 'Add more items',
    'welcome.fastestHelp': 'Fastest Help',
    'welcome.trustBadge': 'Trusted. Secure. Private.',
    'welcome.tapToSpeak': 'Tap to speak',
    'welcome.listening': 'Listening...',
    'welcome.aiGreeting': "Tell me about your project and I'll build you a shopping list of everything you need.",
    'welcome.aiGreetingAssociate': 'While you wait for an associate to meet you, let me know what you need help with and I might be able to point you in the right direction.',
    'welcome.aiHelpWhileWait': 'Get AI help while you wait',
    'welcome.aiHelpSubline': 'Get answers now — no need to wait around',
    'welcome.helpWhileWaitMic': 'Get help while you wait — Talk with AI Associate',
    'welcome.aiHelpRecommended': 'Recommended',
    'welcome.aiGreetingContractor': "Tell me about your project, and I'll connect you with one of our trusted contractors.",
    'welcome.aiConfirmContractor': "Great. I'm reaching out to a few trusted contractors in your area — they'll be in touch shortly with quotes.",
    'welcome.contractorSummaryTitle': '12×16 Attached Deck Build',
    'welcome.contractorSummaryLabel': 'Project Summary',
    'welcome.contractorSummaryBody': 'Build a new 12 ft × 16 ft pressure-treated wood deck (≈192 sq ft) attached to the rear of the house at the back door. Includes footings, framing, decking boards, railings, and stairs.',
    'welcome.contractorScope': 'Scope',
    'welcome.contractorScope1': 'Ledger board + concrete footings',
    'welcome.contractorScope2': 'Pressure-treated framing & joists',
    'welcome.contractorScope3': 'Decking, railings & stairs',
    'welcome.contractorEstimateLabel': 'Estimated Project Cost',
    'welcome.contractorEstimateNote': 'Materials + labor · final quote may vary',
    'welcome.contractorFormNote': "Enter your details and we'll have a trusted local contractor call you to formally quote this project within 1 hour.",
    'welcome.contractorRecapDesc': '12 ft × 16 ft attached pressure-treated wood deck',
    'welcome.contractorRecapEstimate': 'Est. cost',
    'welcome.contractorPhoneLabel': 'Phone number',
    'welcome.contractorPhonePlaceholder': '(555) 123-4567',
    'welcome.contractorZipLabel': 'ZIP code',
    'welcome.contractorZipPlaceholder': '90210',
    'welcome.contractorZipHint': 'So we connect you with contractors in your area.',
    'welcome.contractorSubmit': 'Request my callback',
    'welcome.contractorMatchesTitle': "We'll send your bid to these contractors",
    'welcome.contractorMatchesNote': 'All vetted, top-rated contractors near you',
    'welcome.contractorSubmittedTitle': "You're all set!",
    'welcome.contractorSubmittedNote': 'A trusted local contractor will call you to formally quote your project within the next hour.',
    'welcome.aiGreetingDiy': "Tell me what you're trying to do, and I'll walk you through it step by step.",
    'welcome.aiConfirmDiy': "Got it. Here's how to tackle your project — I'll guide you through each step.",
    'welcome.aiGreetingAddMore': 'Sure — what else would you like to add to your list?',
    'welcome.aiConfirmAddMore': "Done — I've added those to your shopping list.",
    'welcome.diyStepsTitle': 'How to Install a Bathroom Faucet',
    'welcome.diyStepsSubtitle': 'Estimated time: 45 min · Beginner friendly',
    'welcome.diyShare': 'Share these instructions',
    'welcome.diyStep1': 'Turn off the hot & cold water supply valves under the sink.',
    'welcome.diyStep2': 'Disconnect the supply lines and remove the old faucet.',
    'welcome.diyStep3': 'Clean the sink surface and set the new rubber gasket.',
    'welcome.diyStep4': 'Position the new faucet and secure it from underneath.',
    'welcome.diyStep5': 'Reconnect the supply lines to hot & cold inlets.',
    'welcome.diyStep6': 'Turn the water back on and check for leaks.',
    'welcome.diyPoweredBy': 'Guided by Docent Labs',
    'welcome.diyViewFull': 'Tap to view the full guide',
    'welcome.diyViewFullCallout': 'See the full step-by-step guide',
    'welcome.diyViewFullCalloutNote': 'Tools, detailed steps, pro tips & safety warnings',
    'welcome.diyGuideTools': 'Tools & Materials',
    'welcome.diyGuideToolsList': 'Adjustable wrench · Basin wrench · Plumber’s putty · Bucket · Towel · New faucet kit',
    'welcome.diyGuideStepsLabel': 'Step-by-Step',
    'welcome.diyGuideTip': 'Pro tip',
    'welcome.diyGuideWarn': 'Heads up',
    'welcome.diyDetail1Title': '1. Shut off the water',
    'welcome.diyDetail1Body': 'Locate the hot and cold shut-off valves under the sink and turn both clockwise until they stop. Open the faucet to release pressure and confirm the water is fully off.',
    'welcome.diyDetail1Tip': 'Place a bucket and towel under the valves to catch any residual water.',
    'welcome.diyDetail2Title': '2. Remove the old faucet',
    'welcome.diyDetail2Body': 'Use a basin wrench to disconnect the supply lines from the faucet tailpieces. Loosen the mounting nuts underneath and lift the old faucet out from the top.',
    'welcome.diyDetail2Warn': 'Old nuts can be corroded — apply penetrating oil and give it a few minutes if they won’t budge.',
    'welcome.diyDetail3Title': '3. Clean & prep the surface',
    'welcome.diyDetail3Body': 'Scrape away old putty or gasket residue and wipe the sink deck clean. A smooth, dry surface ensures a watertight seal for the new faucet.',
    'welcome.diyDetail4Title': '4. Set the new faucet',
    'welcome.diyDetail4Body': 'Feed the new faucet’s supply lines and tailpieces through the mounting holes. Press the base firmly onto the gasket, then hand-tighten the mounting nuts from below before snugging with a wrench.',
    'welcome.diyDetail4Tip': 'Keep the faucet centered and straight while a helper tightens from underneath.',
    'welcome.diyDetail5Title': '5. Connect the supply lines',
    'welcome.diyDetail5Body': 'Attach the hot line to the left inlet and cold to the right. Tighten the connections by hand, then give a final quarter-turn with a wrench — don’t over-tighten.',
    'welcome.diyDetail6Title': '6. Turn on & test',
    'welcome.diyDetail6Body': 'Slowly reopen the shut-off valves and run both hot and cold water. Check every connection for drips, and tighten slightly if you spot any moisture.',
    'welcome.diyDetail6Warn': 'Run the water for a full minute and re-check under the sink after 24 hours.',
    'welcome.listTitle': 'Your Shopping List',
    'welcome.listSubtitle': "Here's what you'll need.",
    'welcome.swipeHint': 'swipe left to remove',
    'list.swipeToDelete': 'Swipe left to delete',
    'welcome.ronaGuidesTitle': 'RONA Workshop guides for your project',
    'welcome.ronaGuidesSource': 'Step-by-step guides from rona.ca/workshop',
    'welcome.onSale': 'On Sale · tap for details',
    'welcome.projectSummary': 'Your project',
    'welcome.tapToAddMore': 'Tap to add more',
    'welcome.voice': 'Voice',
    'welcome.text': 'Text',
    'welcome.dealsTitle': "Today's Deals",
    'welcome.dealsSubtitle': 'Browse by category',
    'deals.tools': 'Tools',
    'deals.paint': 'Paint',
    'deals.lumber': 'Lumber',
    'deals.electrical': 'Electrical',
    'deals.plumbing': 'Plumbing',
    'deals.garden': 'Garden',
    'deals.dealsCount': 'deals',
    'deals.off': 'OFF',
    'deals.msrp': 'MSRP',
    'deals.productsTitle': 'Deals',
    'welcome.requestAssociate': 'Request RONA Associate',
    'welcome.associateOnWay': 'Associate on the way…',
    'welcome.associateHere': 'Your associate has arrived',
    'welcome.associateArrivedTap': 'Tap when associate arrives',
    'associate.requesting': 'Requesting...',
    'associate.onTheWay': 'Associate on the way',
    // Chat
    'chat.greeting.shoppingList': "Tell me about your project and I'll build you a shopping list of everything you need.",
    'chat.greeting.diy': "Tell me about your project and I'll provide instructions on how to do it yourself.",
    'chat.greeting.contractor': 'Tell me about the project you want the contractor to quote.',
    'chat.greeting.general': 'I can answer any questions you have about your project or product here in the store.',
    'chat.greeting.default': 'Great. Will the deck be attached to your home?',
    'chat.tapToSpeak': 'Tap to speak',
    'chat.listening': 'Listening...',
    'chat.header.shoppingList': 'Shopping List Assistant',
    'chat.header.diy': 'DIY Instructions',
    'chat.header.contractor': 'Contractor Quote',
    'chat.header.general': 'AI Shopping Assistant',
    'chat.header.default': 'Project Setup',
    'chat.step.describe': 'Describe your project',
    // Shopping List
    'list.title': 'My Shopping List',
    'list.subtitle': "Type a product or tap the mic — we'll tell you the aisle.",
    'list.searchPlaceholder': 'What are you looking for?',
    'list.searchHint': 'Try: "hammer", "interior paint", "deck screws"',
    'list.sectionTitle': 'Shopping List',
    'list.empty': 'Your list is empty',
    'list.emptyHint': 'Search for a product above to get started.',
    'list.aiAssistant': 'AI Shopping Assistant',
    'list.addMore': 'Add more to your list',
    'list.tapToStop': 'Tap to stop',
    'list.listening': "Listening… I'm all ears",
    'list.listeningHint': 'Tell me what else to add, then tap stop and I\u2019ll drop it on your list.',
    'list.chatUserMsg': 'Add paint, a brush, painters tape and a drop cloth for my project.',
    'list.chatAiMsg': 'Done — I added paint, a paint brush, painters tape, and a drop cloth to your list.',
    'list.back': 'Back',
    'list.requestAssociate': 'Request RONA Associate',
    'list.associateConfirm': "We've notified the nearest associate.",
    'list.associateWait': 'Estimated wait: 2 minutes',
    // Header
    'header.poweredBy': 'Powered by',
    'header.shoppingList': 'My shopping list'
  },
  fr: {
    // Welcome
    'welcome.headline': 'Comment pouvons-nous vous aider?',
    'welcome.find': 'Trouver un produit en magasin',
    'welcome.list': "Créer une liste d'achats",
    'welcome.mostPopular': 'Le plus populaire',
    'welcome.diy': 'Instructions pour projet bricolage',
    'welcome.contractor': "Soumissions d'entrepreneurs de confiance",
    'welcome.deals': 'OFFRES du jour',
    'welcome.orDescribe': "Parler avec l'associé IA",
    'welcome.talkToAI': "Parler avec l'associé IA",
    'welcome.addMoreItems': "Ajouter d'autres articles",
    'welcome.fastestHelp': 'Aide la plus rapide',
    'welcome.trustBadge': 'Fiable. Sécurisé. Privé.',
    'welcome.tapToSpeak': 'Touchez pour parler',
    'welcome.listening': "À l'écoute...",
    'welcome.aiGreeting': "Parlez-moi de votre projet et je vais créer une liste d'achats avec tout ce dont vous avez besoin.",
    'welcome.aiGreetingAssociate': "En attendant qu'un associé vienne vous rencontrer, dites-moi ce dont vous avez besoin et je pourrai peut-être vous orienter.",
    'welcome.aiHelpWhileWait': "Obtenir de l'aide de l'IA en attendant",
    'welcome.helpWhileWaitMic': "Obtenez de l'aide en attendant — Parlez avec l'associé IA",
    'welcome.aiHelpSubline': 'Des réponses tout de suite — pas besoin d’attendre',
    'welcome.aiHelpRecommended': 'Recommandé',
    'welcome.aiGreetingContractor': "Parlez-moi de votre projet et je vous mettrai en contact avec l'un de nos entrepreneurs de confiance.",
    'welcome.aiConfirmContractor': 'Parfait. Je contacte quelques entrepreneurs de confiance dans votre région — ils vous enverront des soumissions sous peu.',
    'welcome.contractorSummaryTitle': 'Construction de terrasse 12×16',
    'welcome.contractorSummaryLabel': 'Résumé du projet',
    'welcome.contractorSummaryBody': "Construire une nouvelle terrasse en bois traité de 12 pi × 16 pi (≈192 pi²) attachée à l'arrière de la maison près de la porte arrière. Comprend semelles, charpente, planches, garde-corps et marches.",
    'welcome.contractorScope': 'Portée',
    'welcome.contractorScope1': 'Solive de support + semelles en béton',
    'welcome.contractorScope2': 'Charpente et solives en bois traité',
    'welcome.contractorScope3': 'Planches, garde-corps et marches',
    'welcome.contractorEstimateLabel': 'Coût estimé du projet',
    'welcome.contractorEstimateNote': 'Matériaux + main-d’œuvre · la soumission finale peut varier',
    'welcome.contractorFormNote': 'Entrez vos coordonnées et un entrepreneur local de confiance vous appellera pour soumissionner officiellement votre projet dans l’heure.',
    'welcome.contractorRecapDesc': 'Terrasse en bois traité de 12 pi × 16 pi attachée',
    'welcome.contractorRecapEstimate': 'Coût estimé',
    'welcome.contractorPhoneLabel': 'Numéro de téléphone',
    'welcome.contractorPhonePlaceholder': '(555) 123-4567',
    'welcome.contractorZipLabel': 'Code postal',
    'welcome.contractorZipPlaceholder': 'H2X 1Y4',
    'welcome.contractorZipHint': 'Pour vous jumeler avec des entrepreneurs de votre région.',
    'welcome.contractorSubmit': 'Demander mon rappel',
    'welcome.contractorMatchesTitle': 'Nous enverrons votre demande à ces entrepreneurs',
    'welcome.contractorMatchesNote': 'Entrepreneurs vérifiés et très bien notés près de chez vous',
    'welcome.contractorSubmittedTitle': 'Tout est prêt !',
    'welcome.contractorSubmittedNote': 'Un entrepreneur local de confiance vous appellera pour soumissionner officiellement votre projet dans la prochaine heure.',
    'welcome.aiGreetingDiy': 'Dites-moi ce que vous essayez de faire et je vous guiderai étape par étape.',
    'welcome.aiConfirmDiy': 'Compris. Voici comment réaliser votre projet — je vous guiderai à chaque étape.',
    'welcome.aiGreetingAddMore': "Bien sûr — qu'aimeriez-vous ajouter d'autre à votre liste ?",
    'welcome.aiConfirmAddMore': "C'est fait — je les ai ajoutés à votre liste d'achats.",
    'welcome.diyStepsTitle': 'Comment installer un robinet de salle de bain',
    'welcome.diyStepsSubtitle': 'Durée estimée : 45 min · Facile',
    'welcome.diyShare': 'Partager ces instructions',
    'welcome.diyStep1': "Fermez les valves d'eau chaude et froide sous le lavabo.",
    'welcome.diyStep2': "Débranchez les conduites et retirez l'ancien robinet.",
    'welcome.diyStep3': 'Nettoyez la surface et posez le nouveau joint en caoutchouc.',
    'welcome.diyStep4': 'Positionnez le nouveau robinet et fixez-le par-dessous.',
    'welcome.diyStep5': 'Rebranchez les conduites aux entrées chaude et froide.',
    'welcome.diyStep6': "Rouvrez l'eau et vérifiez les fuites.",
    'welcome.diyPoweredBy': 'Guidé par Docent Labs',
    'welcome.diyViewFull': 'Touchez pour voir le guide complet',
    'welcome.diyViewFullCallout': 'Voir le guide complet étape par étape',
    'welcome.diyViewFullCalloutNote': 'Outils, étapes détaillées, conseils et avertissements',
    'welcome.diyGuideTools': 'Outils et matériaux',
    'welcome.diyGuideToolsList': 'Clé à molette · Clé à lavabo · Mastic de plombier · Seau · Serviette · Nouveau robinet',
    'welcome.diyGuideStepsLabel': 'Étape par étape',
    'welcome.diyGuideTip': 'Conseil de pro',
    'welcome.diyGuideWarn': 'Attention',
    'welcome.diyDetail1Title': "1. Couper l'eau",
    'welcome.diyDetail1Body': "Repérez les valves d'eau chaude et froide sous le lavabo et tournez-les dans le sens horaire jusqu'à l'arrêt. Ouvrez le robinet pour relâcher la pression et confirmer que l'eau est coupée.",
    'welcome.diyDetail1Tip': 'Placez un seau et une serviette sous les valves pour récupérer l’eau résiduelle.',
    'welcome.diyDetail2Title': "2. Retirer l'ancien robinet",
    'welcome.diyDetail2Body': "Utilisez une clé à lavabo pour débrancher les conduites. Desserrez les écrous de montage en dessous et soulevez l'ancien robinet par le haut.",
    'welcome.diyDetail2Warn': 'Les vieux écrous peuvent être corrodés — appliquez un dégrippant et patientez quelques minutes.',
    'welcome.diyDetail3Title': '3. Nettoyer et préparer',
    'welcome.diyDetail3Body': 'Grattez les résidus de mastic et essuyez la surface. Une surface lisse et sèche assure un joint étanche.',
    'welcome.diyDetail4Title': '4. Poser le nouveau robinet',
    'welcome.diyDetail4Body': 'Passez les conduites du nouveau robinet dans les trous de montage. Pressez la base sur le joint, puis serrez les écrous à la main avant de finir à la clé.',
    'welcome.diyDetail4Tip': 'Gardez le robinet centré et droit pendant qu’un aide serre par-dessous.',
    'welcome.diyDetail5Title': '5. Brancher les conduites',
    'welcome.diyDetail5Body': "Branchez la conduite chaude à l'entrée gauche et la froide à droite. Serrez à la main puis un quart de tour à la clé — sans trop serrer.",
    'welcome.diyDetail6Title': '6. Ouvrir et tester',
    'welcome.diyDetail6Body': "Rouvrez lentement les valves et faites couler l'eau chaude et froide. Vérifiez chaque raccord pour détecter les fuites.",
    'welcome.diyDetail6Warn': 'Laissez couler une minute et re-vérifiez sous le lavabo après 24 heures.',
    'welcome.listTitle': "Votre liste d'achats",
    'welcome.listSubtitle': 'Voici ce dont vous aurez besoin.',
    'welcome.swipeHint': 'glissez vers la gauche pour retirer',
    'list.swipeToDelete': 'Glissez vers la gauche pour supprimer',
    'welcome.ronaGuidesTitle': 'Guides Atelier RONA pour votre projet',
    'welcome.ronaGuidesSource': 'Guides étape par étape de rona.ca/atelier',
    'welcome.onSale': 'En solde · détails',
    'welcome.projectSummary': 'Votre projet',
    'welcome.tapToAddMore': 'Touchez pour ajouter',
    'welcome.voice': 'Voix',
    'welcome.text': 'Texte',
    'welcome.dealsTitle': 'Offres du jour',
    'welcome.dealsSubtitle': 'Parcourir par catégorie',
    'deals.tools': 'Outils',
    'deals.paint': 'Peinture',
    'deals.lumber': 'Bois',
    'deals.electrical': 'Électrique',
    'deals.plumbing': 'Plomberie',
    'deals.garden': 'Jardin',
    'deals.dealsCount': 'offres',
    'deals.off': 'RABAIS',
    'deals.msrp': 'PDSF',
    'deals.productsTitle': 'Offres',
    'welcome.requestAssociate': 'Demander un associé',
    'welcome.associateOnWay': 'Associé en route…',
    'welcome.associateHere': 'Votre associé est arrivé',
    'welcome.associateArrivedTap': "Touchez à l'arrivée de l'associé",
    'associate.requesting': 'Demande en cours...',
    'associate.onTheWay': 'Associé en route',
    // Chat
    'chat.greeting.shoppingList': "Parlez-moi de votre projet et je vais créer une liste d'achats avec tout ce dont vous avez besoin.",
    'chat.greeting.diy': 'Parlez-moi de votre projet et je vais vous fournir des instructions pour le réaliser vous-même.',
    'chat.greeting.contractor': 'Parlez-moi du projet que vous souhaitez faire évaluer par un entrepreneur.',
    'chat.greeting.general': 'Je peux répondre à toutes vos questions sur votre projet ou un produit ici en magasin.',
    'chat.greeting.default': 'Parfait. La terrasse sera-t-elle attachée à votre maison?',
    'chat.tapToSpeak': 'Touchez pour parler',
    'chat.listening': "À l'écoute...",
    'chat.header.shoppingList': "Assistant liste d'achats",
    'chat.header.diy': 'Instructions bricolage',
    'chat.header.contractor': "Évaluation d'entrepreneur",
    'chat.header.general': "Assistant d'achats IA",
    'chat.header.default': 'Configuration du projet',
    'chat.step.describe': 'Décrivez votre projet',
    // Shopping List
    'list.title': "Ma liste d'achats",
    'list.subtitle': "Tapez un produit ou touchez le micro — on vous dira l'allée.",
    'list.searchPlaceholder': 'Que cherchez-vous?',
    'list.searchHint': 'Essayez: "marteau", "peinture", "vis à terrasse"',
    'list.sectionTitle': "Liste d'achats",
    'list.empty': 'Votre liste est vide',
    'list.emptyHint': 'Cherchez un produit ci-dessus pour commencer.',
    'list.aiAssistant': "Assistant d'achats IA",
    'list.addMore': 'Ajoutez à votre liste',
    'list.tapToStop': 'Touchez pour arrêter',
    'list.listening': "À l'écoute…",
    'list.listeningHint': "Dites-moi quoi ajouter, puis touchez arrêter et je l'ajoute à votre liste.",
    'list.chatUserMsg': 'Ajoute de la peinture, un pinceau, du ruban de masquage et une toile de protection pour mon projet.',
    'list.chatAiMsg': "C'est fait — j'ai ajouté de la peinture, un pinceau, du ruban de masquage et une toile de protection à votre liste.",
    'list.back': 'Retour',
    'list.requestAssociate': 'Demander un associé',
    'list.associateConfirm': "Nous avons prévenu l'associé le plus proche.",
    'list.associateWait': "Temps d'attente estimé: 2 minutes",
    // Header
    'header.poweredBy': 'Propulsé par',
    'header.shoppingList': "Ma liste d'achats"
  },
  // Spanish — common keys translated; everything else falls back to English.
  es: {
    // Welcome
    'welcome.headline': '¿Cómo podemos ayudarte?',
    'welcome.find': 'Encontrar productos en la tienda',
    'welcome.list': 'Crear una lista de compras',
    'welcome.mostPopular': 'Más popular',
    'welcome.diy': 'Instrucciones de proyectos',
    'welcome.contractor': 'Cotizaciones de contratistas',
    'welcome.deals': 'OFERTAS de hoy',
    'welcome.orDescribe': 'Habla con el Asociado-IA',
    'welcome.talkToAI': 'Habla con el Asociado-IA',
    'welcome.addMoreItems': 'Añadir más artículos',
    'welcome.fastestHelp': 'Ayuda más rápida',
    'welcome.trustBadge': 'Confiable. Seguro. Privado.',
    'welcome.tapToSpeak': 'Toca para hablar',
    'welcome.listening': 'Escuchando...',
    'welcome.aiGreeting': 'Cuéntame sobre tu proyecto y te crearé una lista de compras con todo lo que necesitas.',
    'welcome.aiGreetingAddMore': '¿Claro — qué más te gustaría añadir a tu lista?',
    'welcome.aiConfirmAddMore': 'Listo — los he añadido a tu lista de compras.',
    'welcome.aiGreetingAssociate': 'Mientras esperas a que un asociado te atienda, dime en qué necesitas ayuda y quizá pueda orientarte.',
    'welcome.aiHelpWhileWait': 'Obtén ayuda con IA mientras esperas',
    'welcome.helpWhileWaitMic': 'Obtén ayuda mientras esperas — Habla con el Asociado IA',
    'welcome.aiHelpSubline': 'Obtén respuestas ahora, sin esperar',
    'welcome.aiHelpRecommended': 'Recomendado',
    'welcome.aiGreetingContractor': 'Cuéntame sobre tu proyecto y te conectaré con uno de nuestros contratistas de confianza.',
    'welcome.requestAssociate': 'Solicitar un asociado RONA',
    'welcome.relatedDeals': 'Ofertas relacionadas',
    'welcome.onSale': 'En oferta · ver detalles',
    'welcome.listTitle': 'Tu lista de compras',
    'welcome.listSubtitle': 'Esto es lo que necesitarás.',
    'welcome.swipeHint': 'desliza a la izquierda para quitar',
    'list.swipeToDelete': 'Desliza a la izquierda para eliminar',
    'welcome.projectSummary': 'Proyecto',
    'welcome.voice': 'Voz',
    'welcome.text': 'Texto',
    'welcome.contractorSubmit': 'Solicitar mi llamada',
    'welcome.contractorMatchesTitle': 'Enviaremos tu solicitud a estos contratistas',
    'welcome.contractorMatchesNote': 'Contratistas verificados y mejor calificados cerca de ti',
    'welcome.ronaGuidesTitle': 'Guías del Taller RONA para tu proyecto',
    'welcome.ronaGuidesSource': 'Guías paso a paso de rona.ca/taller',
    'associate.requesting': 'Buscando un asociado...',
    'associate.onTheWay': 'Un asociado va en camino',
    'list.addMore': 'Añade más a tu lista',
    'list.tapToStop': 'Toca para detener',
    'list.listening': 'Escuchando…',
    'list.listeningHint': 'Dime qué más añadir, luego toca detener y lo agrego a tu lista.',
    'list.chatUserMsg': 'Añade pintura, una brocha, cinta de carrocero y una lona protectora para mi proyecto.',
    'list.chatAiMsg': 'Hecho — he añadido pintura, una brocha, cinta de carrocero y una lona protectora a tu lista.',
    'list.back': 'Atrás',
    'list.requestAssociate': 'Solicitar un asociado RONA',
    // Header
    'header.poweredBy': 'Desarrollado por',
    'header.shoppingList': 'Mi lista de compras'
  }
};
type LanguageContextValue = {
  lang: Language;
  setLang: (lang: Language) => void;
  t: (key: TranslationKey) => string;
};
const LanguageContext = createContext<LanguageContextValue | undefined>(undefined);
export function LanguageProvider({
  children
}: {
  children: ReactNode;
}) {
  const [lang, setLang] = useState<Language>('en');
  const t = (key: TranslationKey) => translations[lang][key] ?? translations.en[key] ?? key;
  return <LanguageContext.Provider value={{
    lang,
    setLang,
    t
  }} data-id="element-64">
      {children}
    </LanguageContext.Provider>;
}
export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLanguage must be used inside LanguageProvider');
  return ctx;
}